'use client'

import { ButtonImage } from '@/components/common/Button'
import { Icon } from '@/components/icons/Icon'
import { usePage } from '@/components/providers/PageProvider'

import styles from './HomeTopCallout.module.scss'

export const HomeTopCallout = () => {
  const { page } = usePage()

  const { description, heading, image, link } = page?.home?.alert || {}
  if (!image || !heading || !link) return null

  return (
    <div className={styles.container}>
      <ButtonImage as='LinkOutbound' colorPrimary href={link} image={image} size='lg'>
        <div className={styles.button}>
          <span className={styles.icon}>
            <Icon name='circleExclamation' />
          </span>
          <div className={styles.text}>
            <p className={styles.heading}>{heading}</p>
            <p className={styles.description}>{description}</p>
          </div>
        </div>
      </ButtonImage>
    </div>
  )
}
